"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.StyledInput = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(["\n    ", ";\n    margin-bottom: ", "em;\n"], ["\n    ", ";\n    margin-bottom: ", "em;\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n            width: 100%;\n            max-width: ", ";\n            height: ", "em;\n            border-radius: ", "em;\n            border: 1px solid\n                ", ";\n            box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n            padding: 0 ", "em;\n            margin: 0\n                ", "\n                auto ", "em;\n            font-size: 1em;\n        "], ["\n            width: 100%;\n            max-width: ", ";\n            height: ", "em;\n            border-radius: ", "em;\n            border: 1px solid\n                ", ";\n            box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n            padding: 0 ", "em;\n            margin: 0\n                ", "\n                auto ", "em;\n            font-size: 1em;\n        "]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledInput = exports.StyledInput = _styledComponents2.default.input(_templateObject, function (props) {
    return (0, _styledComponents.css)(_templateObject2, function (props) {
        return props.expanded ? "100%" : "10em";
    }, function (props) {
        return props.theme.input.sizes[props.size];
    }, function (props) {
        return props.theme.input.radius;
    }, function (props) {
        return props.error ? props.theme.input.error.borderColor : props.theme.input.borderColor;
    }, function (props) {
        return props.theme.input.sizes[props.size] / 4;
    }, function (props) {
        return props.expanded || props.align == "right" ? 0 : "0.4em";
    }, function (props) {
        return props.align == "right" ? "0.4em" : 0;
    });
}, function (props) {
    return props.theme.input.margin;
});

var DatePickerInputField = function (_Component) {
    _inherits(DatePickerInputField, _Component);

    function DatePickerInputField() {
        _classCallCheck(this, DatePickerInputField);

        return _possibleConstructorReturn(this, (DatePickerInputField.__proto__ || Object.getPrototypeOf(DatePickerInputField)).apply(this, arguments));
    }

    _createClass(DatePickerInputField, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                name = _props.name,
                rest = _objectWithoutProperties(_props, ["name"]);

            return _react2.default.createElement(StyledInput, _extends({ name: name }, rest));
        }
    }]);

    return DatePickerInputField;
}(_react.Component);

DatePickerInputField.displayName = "DatePickerInputField";

DatePickerInputField.propTypes = {
    name: _propTypes2.default.string.isRequired,
    onChange: _propTypes2.default.func.isRequired,
    size: _propTypes2.default.string,
    expanded: _propTypes2.default.bool,
    block: _propTypes2.default.bool,
    input: _propTypes2.default.object,
    type: _propTypes2.default.string,
    label: _propTypes2.default.string,
    readOnly: _propTypes2.default.bool,
    error: _propTypes2.default.string
};

DatePickerInputField.defaultProps = {
    size: "default",
    expanded: true,
    block: true,
    type: "text",
    readOnly: false,
    error: ""
};

exports.default = DatePickerInputField;


//////////////////
// WEBPACK FOOTER
// ./~/rla-components/dist/components/form/datePicker/DatePickerInputField.js
// module id = 1001
// module chunks = 95715928098905 168707334958949